import axios from 'axios';

export default {

  BASE_URL: '',

  requestGet(path) {

    return axios.get( this.BASE_URL + path );
  },

  requestPost(path, data) {

    return axios.post( this.BASE_URL + path, data );
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js